import React from 'react'

import { Button, Panel } from 'rsuite'
import { Link, generatePath } from 'react-router-dom'
import LegacyListIcon from '@rsuite/icons/legacy/List'
import ProductReviewsGrid from '../ProductReviewGrid'

import { ROUTE_CATALOG_PRODUCT_REVIEWS } from '@@partner:config/routes'

export interface ModerationCompleteInfoProps {
  brandSlug: string
  filter: {}
}

export default function ModerationCompleteInfo ({
  brandSlug,
  filter
}: ModerationCompleteInfoProps) {
  return (
    <div className="flex flex-col">
      <Button
        color="green"
        size="sm"
        appearance="primary"
        as={Link}
        to={generatePath(ROUTE_CATALOG_PRODUCT_REVIEWS, {
          brandSlug
        })}
        className="w-1/6 mb-4"
      >
        <LegacyListIcon /> Отзывы на товары
      </Button>
      <h1 className="text-2xl font-bold sm:text-3xl sm:tracking-tight">
        История этой сессии:
      </h1>
      <Panel className="mt-4">
        <ProductReviewsGrid filter={filter} brandSlug={brandSlug} />
      </Panel>
    </div>
  )
}
